import React from "react";
import Navbar from "../html-components/navbar";

function Operations () {
    return (
        <div>
            <Navbar/>
            <div>Hello World! Welcome to Operations</div>
        </div>
    );
};

export default Operations;